const leftNav = [
    {
        id: 1,
        name: '德联商城',
        subname: '产品分类',
        links: '/MallList?productType=1',
        namesub: [
            {
                id: 1,
                sub: '全部',
                links: '/MallList?productType=1'
            },
            {
                id: 3,
                sub: '机油',
                links: '/MallList?productType=3'
            },
            {
                id: 31,
                sub: '汽机油',
                links: '/MallList?productType=31'
            },
            {
                id: 32,
                sub: '柴机油',
                links: '/MallList?productType=32'
            },
            {
                id: 21,
                sub: '变速箱油',
                links: '/MallList?productType=21'
            },
            {
                id: 22,
                sub: '动力转向油',
                links: '/MallList?productType=22'
            },
            {
                id: 23,
                sub: '冷却液',
                links: '/MallList?productType=23'
            },
            {
                id: 24,
                sub: '制动液',
                links: '/MallList?productType=24'
            },
            {
                id: 25,
                sub: '汽车养护用品',
                links: '/MallList?productType=25'
            }

        ]
    },    
    {
        id: 2,
        name: '我的德联',
        links: '/MyDelian',
        namesub: [
            {
                id: 21,
                sub: '订单信息',
                links: '#',
                namesub: [
                    {
                        id: 211,
                        sub: '我的订单',
                        links: '/MyDelian'
                    },
                    {
                        id: 212,
                        sub: '发票管理',
                        links: '/InvoiceManagement'
                    }
                ]

            },
            {
                id: 22,
                sub: '积分信息',
                links: '#',
                namesub: [
                    {
                        id: 221,
                        sub: '我的积分',
                        links: '/MyPoint'
                    }
                ]

            },
            {
                id: 23,
                sub: '账户信息',
                links: '#',
                namesub: [
                    {
                        id: 231,
                        sub: '联系人管理',
                        links: '/ContactManagement'
                    },
                    {
                        id: 232,
                        sub: '地址管理',
                        links: '/AddressManagement'
                    }
                ]

            }
        ]
    }
]

export default leftNav;